import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * P0.4 — guarda de `/hoje`.
 *
 * "O meu dia" é a casa de qualquer operador, com a flag
 * `operator_mode_enabled` ligada ou desligada (auditoria 2026-10). Gestor e
 * admin voltam ao destino de sempre, `/dashboard`. O perfil já é conhecido
 * quando a rota protegida chega aqui, por isso não há config de que esperar.
 *
 * Sem risco de ciclo: `/dashboard` só devolve a `/hoje` em modo operador, e
 * aí o utilizador é operador.
 */
export default function OperatorHomeRoute({ children }) {
  const { user } = useAuth();
  if (user?.role !== "operador") return <Navigate to="/dashboard" replace />;
  return children;
}
